import { render } from "./CourseLiveExamList.vue?vue&type=template&id=61ccc933"
import script from "./CourseLiveExamList.vue?vue&type=script&lang=js"
export * from "./CourseLiveExamList.vue?vue&type=script&lang=js"

import "./CourseLiveExamList.vue?vue&type=style&index=0&id=61ccc933&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__